import React, { Suspense, useEffect } from 'react';
import { useAntLocale } from '@fuxi/eevee-hooks';
import { Outlet, useNavigate } from 'react-router-dom';
import { useNavigationLang } from '@portalCommon/hooks';
import { INITIAL_PORTAL_INDEX_URL } from '@portalCommon/constants';
import { SUPPORT_LANG_LIST } from '@yaotai/common-utils';

export const LanguageLayout = () => {
  const { changeLanguage } = useAntLocale();
  const navigate = useNavigate();

  const { lang } = useNavigationLang();

  useEffect(() => {
    if (!SUPPORT_LANG_LIST.includes(lang || '')) return navigate(INITIAL_PORTAL_INDEX_URL);
    localStorage.setItem('HAS-CONFIG-LANG', lang!);
    changeLanguage(lang!);
  }, [changeLanguage, lang, navigate]);

  return (
    <>
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </>
  );
};
